document.addEventListener('DOMContentLoaded', function(){

  // Sans IntersectionObserver (vieux navigateur), on affiche tout plutot que de laisser la page vide.
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.hg-fade-up').forEach(function(el){ el.classList.add('hg-visible'); });
    window.__hgAnimOK = true;
    return;
  }

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('hg-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.hg-fade-up').forEach(function(el){
    if (!el.classList.contains('hg-visible')) observer.observe(el);
  });

  // Signale au filet de securite de theme.liquid que les animations tournent.
  window.__hgAnimOK = true;

});
